<template>
  <div class="pt-4">
    <div v-if="isLoaded">
      <div v-if="!spinSettings.CMSpinPlayerURL" data-test="spinError">
        <div class="py-5 px-2 px-sm-5">
          <div class="text-center">
            <img :src="require('@/assets/error-general.svg')" width="64" height="48" alt="" />
          </div>
          <div class="text-center">
            <h2 class="my-4">{{ $t('message.spin.spinError.heading') }}</h2>
            <p class="error-message px-3 px-sm-4">{{ $t('message.spin.spinError.msg') }}</p>
          </div>
        </div>
      </div>
      <div v-else>
        <iframe :src="spinSettings.CMSpinPlayerURL" allow="fullscreen" style="width: 100%; height: 70vh; border: 0" />
      </div>
    </div>
    <div v-else class="spin-placeholder-wrapper">
      <div class="spin-placeholder"></div>
    </div>
    <div class="mt-4">
      <ProductCTAs></ProductCTAs>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ProductCTAs from '@/components/ProductCTAs.vue';
import log from '@/services/log';

export default {
  name: 'SpinView',
  components: {
    ProductCTAs,
  },
  data() {
    return {};
  },
  computed: {
    ...mapState('spin', ['spinSettings', 'spinError', 'isLoaded']),
  },
  mounted() {
    if (this.isLoaded) {
      if (this.spinError) {
        this.spinErrorCallback('Error spin already has error on page load', new Error());
      } else if (!this.spinSettings.CMSpinPlayerURL) {
        this.spinErrorCallback('Error failed to load CM spin URL', new Error());
      }
    }
  },
  watch: {
    spinError(newValue) {
      if (newValue) {
        this.spinErrorCallback('Error spin already has error on page load', new Error());
      }
    },
    spinSettings(newValue) {
      if (!newValue.CMSpinPlayerURL) {
        log('Error failed to load CM spin URL', new Error());
      }
    },
  },
  methods: {
    spinErrorCallback(msg, error) {
      log(msg, error);
      this.$store.commit('spin/SET_SPIN_ERROR', true);
    },
  },
};
</script>

<style lang="scss" scoped>
// Placeholder to save space for player
.spin-placeholder-wrapper {
  max-width: 100%;
}

.spin-placeholder {
  width: 100%;
  padding-bottom: 56.25%;
}
</style>
